<div class="dashboards"
     *renderingPermissionDirective="['DeviceMonitoringWriter', 'DeviceMonitoringReader', 'DeviceMonitoringAdmin']">
  <div class="dashboards__content">
    <dcc-page-title title="OpenSearch"></dcc-page-title>

    <div class="dashboards__list">
      <div class="dashboards__description">For OpenSearch access, please contact Lytx IT Help to add an OpenSearch tile
        to your Okta apps.</div>
      <div class="dashboards__reports-label">Reports</div>
      <div class="dashboards__report">
        <div class="dashboards__report-icon"><i class="lx-icon lx-lftnav-licenses"></i></div>
        <div class="dashboards__report-text">
          <div *ngFor="let dashboardLink of dashboards">
            <a [href]="dashboardLink.address"
               target="_blank"
               class="dashboards__report-link">{{ dashboardLink.name
              }}</a>
          </div>
          <div class="dashboards__description">Shows count of ECM signals per make/model/year vehicle. Used to
            determine the likelihood of the Lytx Device detecting ECM signals of any given vehicle type.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
